import { useResearchStore } from "@/stores/ResearchStore";
import { useErrorStore } from "@/stores/ErrorStore";
export const ResearchStores = [useResearchStore, useErrorStore];

const LIST_TASKS = ["surveys", "kpis", "campaigns"];

export const ResearchChannel = {
  async received(payload) {
    if (payload.status === "error") {
      const listTask = LIST_TASKS.find(
        (task) => this.researchStore.taskIds[task] === payload.id,
      );
      if (listTask) {
        this.researchStore.loading[listTask] = false;
        this.researchStore.taskIds[listTask] = undefined;
        this.errorStore.showError(payload.message);
        return;
      }
    }
    if (payload.id === this.researchStore.taskIds.surveys) {
      this.researchStore.surveys = payload.data.surveys;
      this.researchStore.taskIds.surveys = undefined;
      this.researchStore.loading.surveys = false;
    }
    if (payload.id === this.researchStore.taskIds.kpis) {
      this.researchStore.kpis = payload.data.kpis;
      this.researchStore.taskIds.kpis = undefined;
      this.researchStore.loading.kpis = false;
    }
    if (payload.id === this.researchStore.taskIds.campaigns) {
      this.researchStore.campaigns = payload.data.campaigns;
      this.researchStore.taskIds.campaigns = undefined;
      this.researchStore.loading.campaigns = false;
    }
    if (payload.id === this.researchStore.taskIds.surveyDataSingle) {
      if (payload.status === "error") {
        this.researchStore.errors.surveyDataSingle = payload.message;
        this.researchStore.taskIds.surveyDataSingle = undefined;
        this.researchStore.loading.surveyDataSingle = false;
        this.researchStore.surveyDataSingle = undefined;
        return;
      }
      this.researchStore.surveyDataSingle = payload.data.results;
      this.researchStore.taskIds.surveyDataSingle = undefined;
      this.researchStore.loading.surveyDataSingle = false;
    }
    if (payload.id === this.researchStore.taskIds.surveyDataTrended) {
      if (payload.status === "error") {
        this.researchStore.errors.surveyDataTrended = payload.message;
        this.researchStore.taskIds.surveyDataTrended = undefined;
        this.researchStore.loading.surveyDataTrended = false;
        this.researchStore.surveyDataTrended = undefined;
        return;
      }
      this.researchStore.surveyDataTrended = payload.data.results;
      this.researchStore.taskIds.surveyDataTrended = undefined;
      this.researchStore.loading.surveyDataTrended = false;
    }
    if (payload.id === this.researchStore.taskIds.surveyDataTrendedQuestionId) {
      if (payload.status === "error") {
        this.researchStore.errors.surveyDataTrendedQuestionId = {
          question_id: payload.data.results[0].question_id,
          message:
            "Something went wrong. Please update the Trend Variables and try again.",
        };
        this.researchStore.taskIds.surveyDataTrendedQuestionId = undefined;
        this.researchStore.loading.surveyDataTrendedQuestionId = false;
        this.researchStore.surveyDataTrendedQuestionId = undefined;
        return;
      }
      const questionId = payload.data.results[0].question_id;
      this.researchStore.surveyDataTrended = (
        this.researchStore.surveyDataTrended ?? []
      ).map((question) => {
        if (question.question_id === questionId) {
          return { ...payload.data.results[0] };
        }
        return question;
      });
      this.researchStore.taskIds.surveyDataTrendedQuestionId = undefined;
      this.researchStore.loading.surveyDataTrendedQuestionId = undefined;
    }
    if (payload.id === this.researchStore.taskIds.modeledDataSingle) {
      if (payload.status === "error") {
        this.researchStore.errors.modeledDataSingle = payload.message;
        this.researchStore.taskIds.modeledDataSingle = undefined;
        this.researchStore.loading.modeledDataSingle = false;
        this.researchStore.modeledDataSingle = undefined;
        return;
      }
      this.researchStore.modeledDataSingle = payload.data.results;
      this.researchStore.taskIds.modeledDataSingle = undefined;
      this.researchStore.loading.modeledDataSingle = false;
    }
    if (payload.id === this.researchStore.taskIds.modeledDataTrended) {
      if (payload.status === "error") {
        this.researchStore.errors.modeledDataTrended = payload.message;
        this.researchStore.taskIds.modeledDataTrended = undefined;
        this.researchStore.loading.modeledDataTrended = false;
        this.researchStore.modeledDataTrended = undefined;
        return;
      }
      this.researchStore.modeledDataTrended = payload.data.results;
      this.researchStore.taskIds.modeledDataTrended = undefined;
      this.researchStore.loading.modeledDataTrended = false;
    }
  },
};
